import React, { memo } from 'react';
import IntersectionObserver from '@/ui/IntersectionObserver';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import { TopEventsBoxes } from '@/betbook/views/BetbookTopEvents';
import Homepage10NajTop5 from 'nike-ui/src/components/homepage/components/Homepage10NajTop5';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import HomepageTop5 from 'nike-ui/src/components/homepage/components/HomepageTop5';
import HomepageTop10 from 'nike-ui/src/components/homepage/components/HomepageTop10';
import { MatchMediaProvider } from 'nike-ui/src/components/turboLive/hooks/useMatchMedia';
import { RequiresNikeone } from 'nike-ui/src/components/nikeone/RequiresNikeone';

const Naj10Top5Module = () => (
    <BetLocationContext.Provider value={{ betLocationSection: betLocation.HP_BETBOOK }}>
        <div className="module-separator" />
        <TurboLiveProvider>
            <MatchMediaProvider>
                <Homepage10NajTop5>
                    <HomepageTop5 otherClass="mt-30" />
                    <HomepageTop10>
                        <TopEventsBoxes dataAtid="naj10-box" />
                    </HomepageTop10>
                </Homepage10NajTop5>
            </MatchMediaProvider>
        </TurboLiveProvider>
        <div className="module-separator" />
    </BetLocationContext.Provider>
);

export const IONaj10Top5Module = memo(function IONaj10Top5Module() {
    return (
        <RequiresNikeone>
            <IntersectionObserver>{() => <Naj10Top5Module />}</IntersectionObserver>
        </RequiresNikeone>
    );
});
